import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';
import FormRequestResetPassword from 'src/screens/forgot-password/components/RequestResetPasswordForm';
import FormResetPassword from 'src/screens/forgot-password/components/ResetPasswordForm';
import BackgroundImageLayout from 'src/shared-components/Layout/BackgroundImageLayout';

const SignIn = () => {
  const router = useRouter();
  const [requestSent, setRequestSent] = useState<boolean>(false);

  return (
    <BackgroundImageLayout backgroundImage="bg-apply">
      <div>
        {router.query.token ? (
          <>
            <h1 className="text-2xl font-bold text-center">Set up a new password</h1>
            <div className="mt-8">
              {requestSent ? (
                <div className="text-center">
                  Please check your email. We sent you a recovery link so you can easily set up a new password.
                </div>
              ) : (
                <FormResetPassword token={String(router.query.token)} onPasswordReset={() => router.push('/signin')} />
              )}
            </div>
          </>
        ) : (
          <>
            <h1 className="text-2xl font-bold text-center">Forgot your password</h1>
            <div className="mt-8">
              {requestSent ? (
                <div className="text-center">
                  Please check your email. We sent you a recovery link so you can easily set up a new password.
                </div>
              ) : (
                <FormRequestResetPassword onRequestSent={() => setRequestSent(true)} />
              )}
            </div>
          </>
        )}
      </div>
      <div className="text-xs text-center w-4/5	m-auto mt-8">
        Do you remember your password?{' '}
        <Link href="/signin">
          <a className="font-bold"> Sign in</a>
        </Link>
      </div>
    </BackgroundImageLayout>
  );
};

export default SignIn;
